import {
  ADD_LIVE_STREAM,
  REMOVE_LIVE_STREAM,
  CLEAR_LIVE_STREAMS,
  SET_SHOW_LIVE_HOST_MODAL,
  SET_SHOW_LIVE_VIEW_MODAL,
  SET_SHOW_LIVE_VIEWER,
  SET_LIVE_ENTITY,
  SET_HOST_LIVE_MINIMIZED,
  SET_VIEW_LIVE_MINIMIZED,
} from "../Constants";

export const addLiveStream = (stream: any) => ({
  type: ADD_LIVE_STREAM,
  payload: stream,
});

export const removeLiveStream = (channelId: string) => ({
  type: REMOVE_LIVE_STREAM,
  payload: channelId,
});

export const clearLiveStreams = () => ({
  type: CLEAR_LIVE_STREAMS,
});

export const setShowLiveHostModal = (value: boolean) => ({
  type: SET_SHOW_LIVE_HOST_MODAL,
  payload: value,
});

export const setShowLiveViewModal = (value: boolean) => ({
  type: SET_SHOW_LIVE_VIEW_MODAL,
  payload: value,
});

export const setShowLiveViewer = (value: any) => ({
  type: SET_SHOW_LIVE_VIEWER,
  payload: value,
});

export const setLiveEntity = (value: any) => ({
  type: SET_LIVE_ENTITY,
  payload: value,
});

export const setHostLiveMinimized = (value: boolean) => ({
  type: SET_HOST_LIVE_MINIMIZED,
  payload: value,
});

export const setViewLiveMinimized = (value: boolean) => ({
  type: SET_VIEW_LIVE_MINIMIZED,
  payload: value,
});
